<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :append-to-body="true" :close-on-click-modal="false" width="55%" :visible.sync="viewData.visible">
    <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="mini">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <!-- <el-descriptions-item label="第几轮报价" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="roundNo" style="margin-bottom: 0;">
                        <span>{{dataForm.roundNo}}</span>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="零件编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.partCode" placeholder="零件编码"></el-input>
                        <span v-else>{{dataForm.partCode}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.partName" placeholder="零件名称"></el-input>
                        <span v-else>{{dataForm.partName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="外购供应商" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="outsourcingSupplier" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.outsourcingSupplier" placeholder="外购供应商"></el-input>
                        <span v-else>{{dataForm.outsourcingSupplier}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="国家" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="country" style="margin-bottom: 0;">
                        <el-input v-if="viewFlag !== 'view'" v-model="dataForm.country" placeholder="国家"></el-input>
                        <span v-else>{{dataForm.country}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单价(A)元/个" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="unitPrice" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.unitPrice" placeholder="单价(A)元/个"></ctl-number>
                        <span v-else>{{dataForm.unitPrice}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="数量(B)" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="quantity" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.quantity" country="数量(B)"></ctl-number>
                        <span v-else>{{dataForm.quantity}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="合计(C=A*B)元" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="summation" style="margin-bottom: 0;">
                        <span>{{dataForm.summation}}</span>
                        <!-- <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.summation" placeholder="合计(C=A*B)元"></ctl-number>
                        <span v-else>{{dataForm.summation}}</span> -->
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="viewData.visible = false">
            取消
        </el-button>
        <el-button size="mini" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            提交
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    getRfqQuotationById,
    editRfqQuotationOutBuy,
    createRfqQuotationOutBuy,
    getRfqBaseById
} from '@/controller/quotation'
import moment from 'moment'
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockContract');
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            dataList: [],
            viewFlag: '',
            dataForm: {
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                partCode: '',
                partName: '',
                outsourcingSupplier: '',
                supplierId: '',
                roundNo: '',
                country: '',
                unitPrice: 0,
                quantity: 0,
                summation: ''
            },
        }
    },
    watch: {
        'dataForm.unitPrice': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                console.log(nval, this.quantity)
                this.dataForm.summation = nval * this.dataForm.quantity
            },
            deep: true, // 深度监听
        },
        'dataForm.quantity': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                console.log(nval)
                console.log(nval, this.quantity)
                this.dataForm.summation = this.dataForm.unitPrice * nval
            },
            deep: true, // 深度监听
        },
    },
    mounted() {},
    methods: {
        init(id, viewFlag, data, rfqId) {
            console.log(id)
            // this.dataForm = data ? data : this.dataForm
            this.viewFlag = viewFlag
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0
            this.dataForm.rfqId = rfqId
            this.viewData.visible = true
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                if (this.dataForm && this.dataForm.id) {
                    getRfqQuotationById({}, this.dataForm.id).then(data => {
                        console.log(data)
                        if (data && data.code === '00') {
                            this.dataForm = data.body;
                            // this.dataForm.appartmentCode = data.body.appartmentCode;
                            // this.dataForm.appartmentName = data.body.appartmentName;
                            // this.dataForm.outsourcingSupplier = data.body.outsourcingSupplier;
                            // this.dataForm.supplierId = data.body.supplierId;
                            // this.dataForm.roundNo = data.body.roundNo;
                            // this.dataForm.country = data.body.country;
                            // this.dataForm.unitPrice = data.body.unitPrice;
                            // this.dataForm.quantity = data.boby.quantity;
                            // this.dataForm.summation = data.boby.summation;
                        }
                    })
                }
            })
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    getRfqBaseById({}, this.dataForm.rfqId).then(data => {
                        if (data && data.code === '00') {
                            if("2" != data.body.rfqStatus) {
                                this.$message.warning("询价单不是询价中状态，不允许修改报价相关信息")
                            } else {
                                let params = {
                                    'id': this.dataForm.id || undefined,
                                    'rfqId': this.dataForm.rfqId || undefined,
                                    'rfqSupplierId': this.dataForm.rfqSupplierId || undefined,
                                    'rfqPartId': this.dataForm.rfqPartId || undefined,
                                    'partCode': this.dataForm.partCode,
                                    'partName': this.dataForm.partName,
                                    'outsourcingSupplier': this.dataForm.outsourcingSupplier,
                                    'supplierId': this.dataForm.supplierId,
                                    'roundNo': this.dataForm.roundNo,
                                    'country': this.dataForm.country,
                                    'unitPrice': this.dataForm.unitPrice,
                                    'quantity': this.dataForm.quantity,
                                    'summation': this.dataForm.summation,
                                }
                                if (this.dataForm.id) {
                                    editRfqQuotationOutBuy(params).then(data => {
                                        if (data && data.code === '00') {
                                            this.$message({
                                                message: '操作成功',
                                                type: 'success',
                                                onClose: () => {
                                                    this.viewData.visible = false
                                                    this.$emit('refreshDataList')
                                                    this.$emit('getDataListAll')
                                                }
                                            })
                                        } else {
                                            this.$message.error(data.msg)
                                        }
                                    })
                                } else {
                                    createRfqQuotationOutBuy(params).then(data => {
                                        if (data && data.code === '00') {
                                            this.$message({
                                                message: '操作成功',
                                                type: 'success',
                                                onClose: () => {
                                                    this.viewData.visible = false
                                                    this.$emit('refreshDataList')
                                                    this.$emit('getDataListAll')
                                                }
                                            })
                                        } else {
                                            this.$message.error(data.msg)
                                        }
                                    })
                                }
                            }
                        }
                    })
                }
            })
        },
        getStyle() {
            return 'width: 130px; text-align: right'
        },
        getStyle2() {
            // return 'width: 647.5px;'
        }
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
